var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "390.5px",
    height: "392.75px",
    viewBox: "0 0 390.5 392.75",
    enableBackground: "new",
    xmlSpace: "default",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M0,392.5c92.75-47.75,229-125.25,390.5-238.25c0-38,0-38,0-38C248.5,209.25,103.75,284,0,333.5V392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M0,279.25C103.5,237,248,171.75,390.5,87c0-18.75,0-18.75,0-18.75c-134,66.5-273,108.25-390.5,134V279.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M390.5,392.75c0-191,0-191,0-191c-88.75,75-177,140-251,191H390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M89.75,392.75C160,351,245.25,296.5,330,233c20-15,40.25-30.25,60.5-46c0-23.75,0-23.75,0-23.75 C265,257.5,136.5,336,36.25,392.75H89.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M0,174.5c114.25-20,254-56.25,390.5-121c0-21.5,0-21.5,0-21.5C253,94,115.25,120,0,129.5V174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C7D",
    d: "M0,0c0,109.5,0,109.5,0,109.5c8.5-0.5,17.25-1.25,26-2c95-7.25,224.75-24,364.5-84.5c0-23,0-23,0-23H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,109.5c0,20,0,20,0,20C115.25,120,253,94,390.5,32c0-9,0-9,0-9C250.75,83.5,121,100.25,26,107.5 C17.25,108.25,8.5,109,0,109.5L0,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,202.25c117.5-25.75,256.5-67.5,390.5-134c0-14.75,0-14.75,0-14.75C254,118.25,114.25,154.5,0,174.5 V202.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,333.5C103.75,284,248.5,209.25,390.5,116.25c0-29.25,0-29.25,0-29.25C248,171.75,103.5,237,0,279.25 V333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.75,392.75c49.75,0,49.75,0,49.75,0c74-51,162.25-116,251-191c0-14.75,0-14.75,0-14.75 c-20.25,15.75-40.5,31-60.5,46C245.25,296.5,160,351,89.75,392.75L89.75,392.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,392.75c36.25,0,36.25,0,36.25,0C136.5,336,265,257.5,390.5,163.25c0-9,0-9,0-9 C229,267.25,92.75,344.75,0,392.5V392.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.18f5b143838eca378167d1b318014a25.svg";
export { ForwardRef as ReactComponent };